// extracted by mini-css-extract-plugin
module.exports = {"header":"header-69Ja1nz-","logo":"logo-BwRF7R7V","subjectName":"subjectName-1pAQyQhM"};